import ContentManagementInterface from '../../models/ContentManagementInterface';
import BackendService from 'BackendService';
import FundOpportunityContentCacheImpl, {
  placeholderImageItemContentItem,
} from '../FundOpportunityContentCacheImpl';

class FundOpportunityContentCache extends FundOpportunityContentCacheImpl {
  getContent(
    fundOpportunityId: string,
    type: 'FundOpportunity' | 'FundUpdate' = 'FundOpportunity',
    draft: boolean = false,
    showPlaceHolder: boolean = true,
  ): Promise<ContentManagementInterface | null> {
    return new BackendService()
      .getFundOpportunityContent(type, fundOpportunityId, draft)
      .then((content) => {
        if (content) {
          return JSON.parse(content) as ContentManagementInterface;
        }
        return showPlaceHolder ? this.placeHolderContent : null;
      })
      .catch(() => (showPlaceHolder ? this.placeHolderContent : null));
  }
}

const fundOpportunityContentCache = new FundOpportunityContentCache();

export default fundOpportunityContentCache;
export { placeholderImageItemContentItem };

export const setAssetStorageToken = (token: import('TokenData').default) => {
  fundOpportunityContentCache.setAssetStorageToken(token);
};

export const clearAssetStorageToken = () => {
  fundOpportunityContentCache.clearAssetStorageToken();
};
